module.exports = __webpack_public_path__ + "img/13@3x.347e553e.png";